import React from "react";

export interface SidebarContextType {
  isCollapsed: boolean;
  toggleCollapse: () => void;
  expandedMenus: Record<string, boolean>;
  toggleMenu: (key: string) => void;
}

export const SidebarContext = React.createContext<
  SidebarContextType | undefined
>(undefined);

export const useSidebar = () => {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within SidebarProvider");
  }
  return context;
};
